// extracted by mini-css-extract-plugin
export default {"formContainer":"styles_formContainer__hzKj9","form":"styles_form__M0ONo","resendInvitationWrapper":"styles_resendInvitationWrapper__FM+rz"};